<template lang="pug">
.uk-position-bottom-left.printer-memo
  .uk-position-relative
    .printer-memo__title メモ
    .printer-memo__body(style="white-space: pre-wrap", v-if="memo", v-text="memo")
</template>

<script>
export default {
  computed: {
    memo () { return this.$store.getters.memo }
  },
}

</script>

